import React from "react";
import { Helmet } from "react-helmet";

function DirectorMessage() {
  return (
    <>
      <Helmet>
        <title>Head of The Department Message | University of Education</title>
      </Helmet>
      <div className="DirectorMessageContainer">
        <div id="Heading" data-aos="fade-up">
          <h1>Message of Head of The Department</h1>
        </div>
        <div className="DirectorMessageHeader">
          <div className="DirectorMessageLeft" data-aos="fade-up">
            <p>
              <b>Welcome to University Department of Education, VBU</b>
            </p>
            <br />
            <p>
              I am pleased to welcome you to the University Department of Education, Vinoba Bhave University,
              Hazaribagh. Our department is dedicated to shaping the future of education by nurturing aspiring teachers
              and educational leaders. We foster a culture of academic excellence, critical thinking, and innovation.
            </p>
          </div>
          <div className="DirectorMessageRight" data-aos="fade-left">
            <img src="/Images/Members/Tanwir.jpeg" alt="director-img" />
          </div>
        </div>

        <div className="DirectorMessageMiddle">
          <p data-aos="fade-up">
            The University Department of Education offers a vibrant and inclusive learning environment. 
            We are proud to offer the <b>4-year Integrated B.A./B.Sc.-B.Ed.</b> program and the <b>Master of Education (M.Ed.)</b> program. 
            These courses are designed to equip students with the necessary pedagogical skills, subject knowledge, and ethical values 
            required to excel in the dynamic field of education.
          </p>
          <br />
          <p data-aos="fade-up">
            Our faculty comprises highly qualified and experienced educators who are passionate about teaching, mentoring, and research. 
            We are committed to providing our students with state-of-the-art facilities, including modern classrooms, 
            a well-stocked library, and educational technology resources to enhance their learning experience.
          </p>
          <br />
          <p data-aos="fade-up">
            We believe in holistic development and encourage our students to participate in various co-curricular activities, seminars, 
            and workshops. This not only builds their confidence but also helps them develop leadership qualities and a broader perspective 
            on educational issues.
          </p>
          <br />
          <p data-aos="fade-up">
            I am confident that your journey with the University Department of Education will be transformative and rewarding. 
            We strive to empower you to become competent, compassionate, and visionary educators who will make a significant impact 
            on society.
          </p>
          <br />
          <p data-aos="fade-up">
            I invite you to explore the opportunities available here and join us in our mission to create a brighter future through education. 
            I look forward to welcoming you to our campus!
          </p>
          <br />
        </div>
        <div className="DirectorMessageFooter">
          <div className="Signature" data-aos="fade-up">
            Dr. Md. Tanwir Yunus
            <br />
            Professor
          </div>
        </div>
      </div>
    </>
  );
}

export default DirectorMessage;
